var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 11.2663V6.73301C18.6667 5.73301 18.24 5.33301 17.18 5.33301H14.4867C13.4267 5.33301 13 5.73301 13 6.73301V11.2663C13 12.2663 13.4267 12.6663 14.4867 12.6663H17.18C18.24 12.6663 18.6667 12.2663 18.6667 11.2663Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 17.267V16.067C18.6667 15.067 18.24 14.667 17.18 14.667H14.4867C13.4267 14.667 13 15.067 13 16.067V17.267C13 18.267 13.4267 18.667 14.4867 18.667H17.18C18.24 18.667 18.6667 18.267 18.6667 17.267Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 12.733V17.2663C10.9999 18.2663 10.5733 18.6663 9.51325 18.6663H6.81992C5.75992 18.6663 5.33325 18.2663 5.33325 17.2663V12.733C5.33325 11.733 5.75992 11.333 6.81992 11.333H9.51325C10.5733 11.333 10.9999 11.733 10.9999 12.733Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 6.73301V7.93301C10.9999 8.93301 10.5733 9.33301 9.51325 9.33301H6.81992C5.75992 9.33301 5.33325 8.93301 5.33325 7.93301V6.73301C5.33325 5.73301 5.75992 5.33301 6.81992 5.33301H9.51325C10.5733 5.33301 10.9999 5.73301 10.9999 6.73301Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.29d376dd8bd82359f8293be94e1c1bb5.svg";
export { ForwardRef as ReactComponent };